<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { iso6393 } from 'iso-639-3'
import dayjs from 'dayjs'
import { userLanguage } from '@/plugins/i18n'
import('dayjs/locale/de')
// We do not import locale 'en' because it is set by default

const { locale, availableLocales } = useI18n()

function langCodeToName(code: string) {
  switch (code) {
    case 'en':
      return 'English (US)'
    case 'de':
      return 'Deutsch'
    case 'es':
      return 'Español'
    case 'fr':
      return 'Français'
    case 'pt':
      return 'Português'
    case 'hi':
      return 'Hindee'
    default:
      return code
  }
}

function langIsoCode6391ToIsoCode6393(code: string) {
  return iso6393.find((test) => test.iso6391 === code)?.iso6393
}

function handleSetLocale(code: string) {
  locale.value = code
  userLanguage.value = code
  dayjs.locale(code)
}
</script>

<template>
  <li class="nav-item dropdown">
    <a
      id="languageSelector"
      class="nav-link dropdown-toggle text-dark d-flex align-items-center text-capitalize px-2"
      href="#"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      {{ langIsoCode6391ToIsoCode6393(locale) }}
    </a>
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="languageSelector">
      <li v-for="code in availableLocales" :key="code">
        <a class="dropdown-item text-capitalize" href="#" @click.prevent="handleSetLocale(code)">
          {{ langCodeToName(code) }}
        </a>
      </li>
    </ul>
  </li>
</template>

<style lang="scss" scoped>
li {
  list-style-type: none;

  a::after {
    content: none;
  }
}
</style>
